/* Keep optional sample answers accessible when native validation finds an error.
   This does not submit, initialise, or replace the existing campaign form. */
(() => {
  'use strict';
  const form = document.getElementById('claim-form');
  if (!form) return;
  form.addEventListener('invalid', (event) => {
    const details = event.target.closest('.sample-more-details');
    if (details && form.contains(details)) details.open = true;
  }, true);
})();
